import isFunction = require('lodash/isFunction');
export type TrackFunction = (event: string, data?: any, fn?: () => void) => void;

export interface ITracker {
  track: TrackFunction;
  getDistinctId: () => string;
}

export class BaseTracker implements ITracker {
  public track = (event: string, data: any = {}, fn?: () => void): void => {
    console.log(`[track event][${event}]`, data);
    isFunction(fn) && fn();
  };

  public getDistinctId = (): string => {
    return 'none';
  }
}
